<script>
    import app from "../stores/app";
    import VehicleDriverSelectModal from "./VehicleDriverSelectModal.svelte";

    export let transferId = 0;
    export let transferDate = null;
    export let vehicles;
    export let notes = '';

    let editIndex = null;

    const onVehicleClick = (index) => {
        editIndex = index;
    }

    const closeModal = (data) => {
        if (data) {
            vehicles[editIndex].vehicle = {
                id: data.vehicle.id,
                vehicle_type_id: data.vehicle.type.id,
                licence_no: data.vehicle.licence_no,
            }
            vehicles[editIndex].driver = {
                id: data.driver.id,
                name: data.driver.name
            }
            vehicles[editIndex].transporter_id = data.vehicle.transporter_id;
            vehicles[editIndex].transporter_name = data.vehicle.transporter_name;
        }
        editIndex = null;
    }

    $: {
        vehicles.map(item => {
            let vType = $app.vehicle_types.find(x => x.id == item.vehicle_type_id);
            if (vType) {
                item.type_name = vType.name;
                if (item.vehicle) {
                    if (item.vehicle.vehicle_type_id != item.vehicle_type_id) {
                        item.transporter_id = 0;
                        item.transporter_name = '';
                        item.vehicle = null;
                        item.driver = null;
                    }
                }
            }
        });
    }
</script>

<div class="panel panel-default mb-5">
    <div class="panel-heading">
        Vehicles & Drivers
    </div>
    <div class="panel-body panel-pad">
        {#each vehicles as item, index}
            <div class="form-group">
                <label>{ item.type_name }</label>
                <div class="form-item pointer" on:click="{ () => onVehicleClick(index) }">
                    <div class="form-control transfer-vehicle" class:text-muted={ !item.vehicle }>
                        {#if item.vehicle}
                            <div class="vehicle">
                                { item.vehicle.licence_no }
                            </div>
                        {:else}
                            click to select vehicle and driver
                        {/if}
                        {#if item.driver}
                            <div class="driver">
                                { item.driver.name }
                            </div>
                        {/if}
                    </div>
                    {#if item.transporter_name}
                        <div class="form-item-info">
                            { item.transporter_name }
                        </div>
                    {/if}
                </div>
            </div>
        {/each}

        <hr>
        <textarea class="form-control" bind:value={ notes } placeholder="driver notes"></textarea>
    </div>
</div>
{#if editIndex != null}
    <VehicleDriverSelectModal {transferId} {transferDate}
                              vehicleTypeId={vehicles[editIndex].vehicle_type_id}
                              transporterId={vehicles[editIndex].transporter_id}
                              vehicle="{vehicles[editIndex].vehicle}"
                              driver="{vehicles[editIndex].driver}"
                              disableType
                              closeCallback="{ closeModal }"/>
{/if}

<style>
    .transfer-vehicle {
        position: relative;
        display: flex;
    }

    .transfer-vehicle .vehicle {
        min-width: 80px;
    }

    .transfer-vehicle .driver {
    }
</style>